import Comment from "../../entities/comment";

/**
 * Comment actions
 *
 * Call order:
 *
 * COMMENT_SAVE_QUEUE:	adds the item to the save queue
 * --> COMMENT_SAVE:	modifies the state
 * --> COMMENT_SAVE_SUCCESS: if all went well
 * --> COMMENT_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail COMMENT_SAVE_QUEUE is during the call to COMMENT_SAVE,
 * as adding an item to the queue should never fail.
 */

export const COMMENT_FETCH_ONE_QUEUE: any = 'COMMENT_FETCH_ONE_QUEUE';
export const COMMENT_FETCH_SUCCESS: any = 'COMMENT_FETCH_SUCCESS';
export const COMMENT_FETCH_FAILURE: any = 'COMMENT_FETCH_FAILURE';
export const COMMENT_FETCH_ONE_SUCCESS: any = 'COMMENT_FETCH_ONE_SUCCESS';
export const COMMENT_FETCH_ONE_FAILURE: any = 'COMMENT_FETCH_ONE_FAILURE';

export const COMMENT_SAVE: any = 'COMMENT_SAVE';
export const COMMENT_SAVE_QUEUE: any = 'COMMENT_SAVE_QUEUE';
export const COMMENT_SAVE_SUCCESS: any = 'COMMENT_SAVE_SUCCESS';
export const COMMENT_SAVE_FAILURE: any = 'COMMENT_SAVE_FAILURE';

export const COMMENT_SAVE_MANY: any = 'COMMENT_SAVE_MANY';
export const COMMENT_SAVE_MANY_QUEUE: any = 'COMMENT_SAVE_MANY_QUEUE';
export const COMMENT_SAVE_MANY_SUCCESS: any = 'COMMENT_SAVE_MANY_SUCCESS';
export const COMMENT_SAVE_MANY_FAILURE: any = 'COMMENT_SAVE_MANY_FAILURE';

export const COMMENT_REMOVE: any = 'COMMENT_REMOVE';
export const COMMENT_REMOVE_QUEUE: any = 'COMMENT_REMOVE_QUEUE';
export const COMMENT_REMOVE_SUCCESS: any = 'COMMENT_REMOVE_SUCCESS';
export const COMMENT_REMOVE_FAILURE: any = 'COMMENT_REMOVE_FAILURE';

export const COMMENT_RESTORE: any = 'COMMENT_RESTORE';
export const COMMENT_RESTORE_QUEUE: any = 'COMMENT_RESTORE_QUEUE';
export const COMMENT_RESTORE_SUCCESS: any = 'COMMENT_RESTORE_SUCCESS';
export const COMMENT_RESTORE_FAILURE: any = 'COMMENT_RESTORE_FAILURE';

export const COMMENT_RESTORE_MANY: any = 'COMMENT_RESTORE_MANY';
export const COMMENT_REMOVE_MANY: any = 'COMMENT_REMOVE_MANY';

/* Fetch actions */
export const fetchCommentSuccess = (comments: Comment[], partial: boolean, lastFetch: number) => ({type: COMMENT_FETCH_SUCCESS, comments, partial, lastFetch});
export const fetchCommentFailure = (err: any) => {
		console.error('CommentAction: fetchCommentFailure', err);
		return {type: COMMENT_FETCH_FAILURE, err};
};
export const fetchOneCommentQueue = (commentId: string) => ({type: COMMENT_FETCH_ONE_QUEUE, commentId});
export const fetchOneCommentSuccess = (comment: Comment) => ({type: COMMENT_FETCH_ONE_SUCCESS, comment});
export const fetchOneCommentFailure = (id: string, err: any) => {
		console.error('CommentAction: fetchOneCommentFailure', err);
		return {type: COMMENT_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveComment = (comment: Comment) => {
    // console.debug('⮂ COMMENT_SAVE action', comment?.id);
    return {type: COMMENT_SAVE, comment};
}
export const saveCommentQueue = (comment: Comment) => {
    // console.debug('⮂ COMMENT_SAVE_QUEUE action', comment?.id);
    return {type: COMMENT_SAVE_QUEUE, comment};
}
export const saveCommentSuccess = (comment: Comment) => {
    // console.debug('⮂ COMMENT_SAVE_SUCCESS action', comment?.id);
    return {type: COMMENT_SAVE_SUCCESS, comment};
}
export const saveCommentFailure = (comment: Comment, status: number, message: string) => {
    console.warn(`⮂ COMMENT_SAVE_FAILURE error saving comment: HTTP ${status}: ${message}`, comment?.id);
    return {type: COMMENT_SAVE_FAILURE, comment, status, message};
};

/* SaveMany actions */
export const saveManyComments = (comments: Comment[]) => {
    // console.debug('⮂ COMMENT_SAVE_MANY action', comments?.map(comment => comment?.id).join(','));
    return {type: COMMENT_SAVE_MANY, comments};
}
export const saveManyCommentsQueue = (comments: Comment[]) => {
    // console.debug('⮂ COMMENT_SAVE_MANY_QUEUE action', comments?.map(comment => comment.id).join(','));
    return {type: COMMENT_SAVE_MANY_QUEUE, comments};
}

export const saveManyCommentsSuccess = (comments: Comment[]) => {
    // console.debug('⮂ COMMENT_SAVE_MANY_SUCCESS action', comments?.map(comment => comment.id).join(','));
    return {type: COMMENT_SAVE_MANY_SUCCESS, comments};
}
export const saveManyCommentsFailure = (comments: Comment[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_COMMENTS_FAILURE Error saving comments: HTTP ${status}: ${message}`, comments?.map(comment => comment.id).join(','));
		return {type: COMMENT_SAVE_MANY_FAILURE, comments, status, message};
};

/* Remove actions */
export const removeComment = (comment: Comment) => ({ type: COMMENT_REMOVE, comment });
export const removeCommentQueue = (comment: Comment) => ({ type: COMMENT_REMOVE_QUEUE, comment });
export const removeCommentSuccess = (comment: Comment) => ({ type: COMMENT_REMOVE_SUCCESS, comment });
export const removeCommentFailure = (comment: Comment, status: number, message: string) => {
	console.error(`Redux: removeCommentFailure Error removing comment: HTTP ${status}: ${message}`);
	return ({ type: COMMENT_REMOVE_FAILURE, comment, status, message });
};

/* Restore actions */
export const restoreComment = (comment: Comment) => ({ type: COMMENT_RESTORE, comment });
export const restoreCommentQueue = (comment: Comment) => ({ type: COMMENT_RESTORE_QUEUE, comment });
export const restoreCommentSuccess = (comment: Comment) => ({ type: COMMENT_RESTORE_SUCCESS, comment });
export const restoreCommentFailure = (comment: Comment, status: number, message: string) => {
	console.error(`Redux: restoreCommentFailure Error restoring comment: HTTP ${status}: ${message}`);
	return ({ type: COMMENT_RESTORE_FAILURE, comment, status, message });
};

/* RestoreMany actions */
export const restoreManyComments = (comments: Comment[]) => ({ type: COMMENT_RESTORE_MANY, comments });

/* RemoveMany actions */
export const removeManyComments = (comments: Comment[]) => ({ type: COMMENT_REMOVE_MANY, comments });